import Vue from "vue"
import Vuex from "vuex"
import theme from "@/init/theme"
Vue.use(Vuex)

import live from "./live"
import vod from "./vod"
import services from "./services"
import rss from "./rss"
import router from "@/router"

const store = new Vuex.Store({
  state: {
    device: null,
    guest: null,
    config: null,
    menus: null,
    data: null,
    languages: null,

    error: null,
    splash: true,
    background: null,
    theme: theme,
    router: false,
    routerHistory: { from: null, to: null }
  },
  mutations: {
    device(state, data) {
      state.device = data
    },
    guest(state, data) {
      state.guest = data
    },
    config(state, data) {
      state.config = data
    },
    menus(state, data) {
      state.menus = data
    },
    data(state, data) {
      state.data = data
    },
    languages(state, data) {
      state.languages = data
    },
    error(state, data) {
      state.error = data
    },
    splash(state, data) {
      state.splash = data
    },
    background(state, data) {
      Vue.set(state, "background", data)
    },
    theme(state, data) {
      state.theme = data
    },
    router(state, data) {
      state.router = data
    }
  },
  getters: {
    language: state => {
      const res = Object.values(state.languages || {}).find(language => language.selected)
      return res || { code: "en_US", NAME: "English" }
    },
    languages: state => Object.values(state.languages || {})
  },
  actions: {
    async fetchDevice(context) {
      return __.api.get
        .device(__.device.properties.mac)
        .then(device => {
          if (!Array.isArray(device) || !device.length) return false

          device = device.shift()

          if (device.hasOwnProperty("guest")) {
            const guest = device.guest
            delete device.guest
            if (context.state.guest && context.state.guest.id === guest.id) Object.keys(guest).forEach(key => (context.state.guest[key] = guest[key]))
            else context.commit("guest", guest)
          } else context.commit("guest", null)

          __.guest.check()

          if (["Public", "VIP", "Lobby", "Pub", "Restaurant", "Hall", "Bar", "Pool", "SPA", "Office", "LOFT"].includes(device.using_by))
            sessionStorage.setItem("channel-language", device.using_by)
          else sessionStorage.removeItem("channel-language")

          device.name = `ROOM_${device.index ? device.location + "_" + device.index : device.location}`

          __.device.setName(device.name)
          context.commit("device", device)
          return device
        })
        .catch(err => _$.error(err))
    },
    async setDevice(context, location) {
      __.device.properties.location = location

      return __.api.set.device(__.device.properties).then(result => {
        if (typeof result === "number") return context.dispatch("fetchDevice")
        return false
      })
    },
    async fetchConfig(context) {
      return __.api.get
        .config()
        .then(result => {
          if (typeof result !== "object") throw "Configurations could not be fetching as expected"
          if (result["welcome.type"] === "2" && !sessionStorage.getItem("welcome") && __.guest.get()) store.state.guest.welcome = "0"

          for (const locale in _$.vue.$i18n.messages) {
            const object = _$.vue.$i18n.messages[locale]
            object.currency = `{0} ${result["view_currency.view_currency"]}`
            _$.vue.$i18n.setLocaleMessage(locale, object)
          }

          context.commit("config", result)
          _$.vue.$emit("config.init", true)
          return true
        })
        .catch(err => _$.error(err))
    },
    async fetchMenu(context) {
      return __.api.get
        .menus()
        .then(result => {
          if (!Array.isArray(result) || !result.length) throw "The platform must contain at least 1 menu"

          const homeRoute = result.find(menu => menu.isHome === "1")

          if (homeRoute && !["DS", "Public"].includes(__.device.get("using_by"))) {
            let target = `/${homeRoute.module.toLowerCase()}`
            if (homeRoute.target) target += `/${homeRoute.target}`
            sessionStorage.setItem("homePage", target)
          } else sessionStorage.setItem("homePage", "/")

          if (__.device.get("using_by") === "DS") router.addRoutes([{ name: "Root", path: "/", redirect: "/DS" }])
          else if (__.device.get("using_by") === "Public") router.addRoutes([{ name: "Root", path: "/", redirect: "/live" }])
          else if (__.device.config("app_startpage.main") === "tv") router.addRoutes([{ name: "Root", path: "/", redirect: "/live" }])
          else router.addRoutes([{ name: "Root", path: "/", redirect: "/home" }])

          context.commit("menus", result)
          return true
        })
        .catch(err => _$.error(err))
    },
    async fetchData(context) {
      try {
        if (!Array.isArray(context.state.menus)) return false
        const data = {}

        for (const menu of context.state.menus) {
          switch (menu.module) {
            case "cms":
              if (menu.target) data[menu.id] = await __.api.get.cms(menu.id)
              if (menu.subs) {
                for (const sub of menu.subs) {
                  data[sub.id] = await __.api.get.cms(sub.id)
                }
              }
              break
            case "vod":
              data["vods"] = await __.api.get.vods().then(vods => {
                if (!Array.isArray(vods)) return []
                vods.map(item => {
                  item.price = item.price == "0" ? null : item.price || null
                  return item
                })
                return vods
              })
              break
          }
        }
        context.commit("data", data)
        return true
      } catch (err) {
        return _$.error(err)
      }
    },
    async fetchLanguages(context) {
      return __.api.get
        .languages()
        .then(languages => {
          if (!languages) throw "The platform must contain at least 1 language"

          Object.values(languages).forEach(language => {
            language.selected = false
          })

          context.commit("languages", languages)
          return true
        })
        .catch(err => _$.error(err))
    },
    async setLanguage(context, language) {
      const lang = language || __.guest.get("language") || sessionStorage.getItem("welcome") || __.device.config("default_language./lang/")
      Object.values(context.state.languages).forEach(language => {
        language.selected = false
        if (language.code === lang) language.selected = true
      })
      return true
    }
  }
})

store.registerModule("live", live)
store.registerModule("vod", vod)
store.registerModule("services", services)
store.registerModule("rss", rss)

export default store
